import Fixture from "@components/competitions/Fixture";

const FixtureTeamsColumn = {
  title: "",
  dataIndex: "home_team_short_name",
  key: "home_team_short_name",
  align: "right",
  render: (_text, record) => {
    return (
      <Fixture
        fixture={record.fixture}
        teams={record.teams}
        goals={record.goals}
        penalty={record.score.penalty}
      />
    );
  },
};

export default FixtureTeamsColumn;
